import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
let lineChart = {};
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    timeIntervalType;
    color;
    minX;
    option = {
        color: [this.color],
        // dataZoom: [
        //     {
        //         show: true,
        //         realtime: true,
        //         start: 0,
        //         end: 20,
        //     },
        //     {
        //         type: 'inside',
        //         realtime: true,
        //         start: 0,
        //         end: 20,
        //     }
        // ],
        grid: {
            top: 10,
            left: 40,
            height: 80,
            width: '95%',
        },
        xAxis: {
            type: 'category',
            show: true,
            boundaryGap: false,
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisLine: {
                lineStyle: { color: '#333' },
            },
        },
        yAxis: {
            type: 'value',
            show: true,
            axisLabel: {
                show: true,
            },
            splitLine: {
                lineStyle: { color: '#333' },
            },
        },
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                const param = params[0];
                // lineChart.setOption({
                //   visualMap: [
                //     {
                //       show: false,
                //       type: 'piecewise',
                //       dimension: 0,
                //       seriesIndex: 0,
                //       pieces: [
                //         {
                //           min: param.dataIndex,
                //           max: this.dataX?.length || 0,
                //           color: '#53A8E2',
                //         },
                //       ],
                //     },
                //   ],
                // });
                return this.dataX[param.dataIndex] + '<br /> ' + this.dataSeries[param.dataIndex];
            },
            axisPointer: {
                animation: false,
                type: 'none',
            },
        },
        visualMap: [
            {
                show: false,
                type: 'piecewise',
                dimension: 0,
                seriesIndex: 0,
                pieces: [
                    {
                        min: 56,
                        max: 60,
                        color: '#53A8E2',
                    },
                ],
            },
        ],
        series: [
            {
                data: [820, 932, 901, 934, 1290, 1330, 1320],
                lineStyle: {
                    color: '#53A8E2',
                },
                type: 'line',
                symbolSize: 7,
                areaStyle: {},
                animation: false,
                showSymbol: false,
                smooth: true,
                emphasis: {
                    itemStyle: {
                        color: '#53A8E2',
                        borderColor: 'rgba(83, 168, 226, 0.49)',
                        borderWidth: 5,
                    },
                },
            },
        ],
    };
    mounted() {
        this.draw();
    }
    draw() {
        this.$nextTick(() => {
            lineChart = echarts.init(this.$refs['line-chart']);
            lineChart.clear();
            lineChart.resize();
            lineChart.setOption(this.option, true);
        });
    }
    onDataXChange(newVal) {
        console.log('datax:', newVal);
        if (!newVal || newVal.length === 0) {
            return;
        }
        this.option.xAxis.data = newVal.map((item, index) => index);
        this.option.series[0].data = this.dataSeries;
        const min = this.findMin();
        const max = newVal.length;
        const pieces = this.option.visualMap.pieces;
        pieces[0].min = min;
        pieces[0].max = max;
        lineChart && lineChart.setOption(this.option);
    }
    findMin() {
        const res = new Date();
        for (let i = 0; i < this.dataX.length; i++) {
            const dataCurr = new Date(this.dataX[i]);
            if (res.getTime() < dataCurr.getTime()) {
                return i;
            }
        }
        return 0;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop()
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeIntervalType", void 0);
__decorate([
    Prop()
], default_1.prototype, "color", void 0);
__decorate([
    Prop()
], default_1.prototype, "minX", void 0);
__decorate([
    Watch('dataX', { immediate: true, deep: true })
], default_1.prototype, "onDataXChange", null);
default_1 = __decorate([
    Component({
        name: 'Dashboard',
    })
], default_1);
export default default_1;
